import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import ChartContext from './DataEntrySection/DataEntryProvider';
import { getSigDigitsUtil } from '../util/util';

function SQCHistogram({ data, chartSigDigits, Xlabel, Ylabel, unit }) {
  const { currentControlStrategyConfigurations } = useContext(ChartContext);

  const renderSigDigits = (stringValue) => {
    return getSigDigitsUtil(
      stringValue,
      currentControlStrategyConfigurations?.chartSigDigits || chartSigDigits
    );
  };

  const uniqueParameters = currentControlStrategyConfigurations?.fullKey
    ? [currentControlStrategyConfigurations.fullKey.split('|').pop()]
    : undefined;

  return (
    <>
      <h5>
        Histogram
        {uniqueParameters?.length
          ? `: ${uniqueParameters.join(', ')}${unit?.trim() ? `, ${unit}` : ''}`
          : unit?.trim()
            ? `: ${unit}`
            : ''}
      </h5>

      <ResponsiveContainer height={400}>
        <ComposedChart data={data} margin={{ top: 5, right: 20, bottom: 15, left: 20 }}>
          <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
          <XAxis
            dataKey="bin"
            label={{
              value: typeof Xlabel === 'string' ? Xlabel : Xlabel?.props?.children,
              position: 'insideBottom',
              offset: -5
            }}
          />
          <YAxis
            label={{
              value: typeof Ylabel === 'string' ? Ylabel : Ylabel?.props?.children,
              angle: -90,
              position: 'insideLeft'
            }}
          />
          <Legend verticalAlign="top" height={36} />
          <Bar dataKey="count" name="Count" barSize={20} fill="#413ea0" />
          <Line
            type="monotone"
            name="Normal PDF"
            label="Normal PDF"
            dataKey="normalPDF"
            stroke="#ff7300"
          />
          <Tooltip formatter={(value) => `${renderSigDigits(value)}`} />
        </ComposedChart>
      </ResponsiveContainer>
    </>
  );
}

SQCHistogram.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  chartSigDigits: PropTypes.number,
  Xlabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  Ylabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

export default SQCHistogram;
